import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { AuthHttp } from 'angular2-jwt';
import { AuthService } from './auth/auth.service';
import { AddContract } from '../models/AddContract';
import { Contract } from '../models/Contract';
import { Router, ActivatedRoute } from '@angular/router';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Registration } from '../models/Registration';
import { Observable } from 'rxjs/Observable';
import { DataService } from './data.service';
import { EmptyObservable } from 'rxjs/observable/EmptyObservable';
import * as Cookie from 'js-cookie';
import { PostedInvoice } from '../models/PostedInvoice';
import { PostInvoiceList } from '../models/PostInvoiceList';


@Injectable()
export class ContractService {

  // private watchSelectedContract = new BehaviorSubject<any>('');
  // public selectedContract = this.watchSelectedContract.asObservable();
  // public selectedContract: any;
  // public contracts: any;

  public selectedContract: Contract;
  public contracts: Contract[];
  public searchText: string;
  public selectedContractNumber: string;
  public header: string;

  // public myjssiContractId: string;
  public myHeader: Headers;
  constructor(private http: Http,
    private authHttp: AuthHttp,
    private route: ActivatedRoute,
    private router: Router,
    public authService: AuthService,
    private dataService: DataService
  ) {
    this.myHeader = new Headers();
    this.myHeader.append('Content-Type', 'application/json');
    // To fix IE 11 cache API issue.
    this.myHeader.append('Cache-control', 'no-cache');
    this.myHeader.append('Cache-control', 'no-store');
    this.myHeader.append('Expires', '0');
    this.myHeader.append('Pragma', 'no-cache');

    console.log('contract Service Initialized...');

    if (!this.dataService.userDisplayInfo) {

      this.authService.logOut();
      // When this is enabled, the login params cannot be got
      //   this.router.navigate(['/pages/login']);
      return;
    }

    const isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);

    // Only for AD users
    if (this.dataService.userDisplayInfo.UserTypeID === 5) {
      if (!this.searchText) {
        // To fix IE 11
        if (isIEOrEdge) {
          this.searchText = Cookie.get('searchText');
        } else {
          const searchTextInStorage = localStorage.getItem('searchText');
          if (searchTextInStorage !== null && typeof searchTextInStorage !== 'undefined') {
            this.searchText = searchTextInStorage;
          }
        }
      }
    } else {
      if (isIEOrEdge) {
        Cookie.remove('searchText');
      } else {
        localStorage.removeItem('searchText');
      }
    }

  }

  // async transmitSelectedContract(data: any) {
  //   await this.watchSelectedContract.next(data);
  // }

  updateHeader(name: string) {
    this.header = name;
  }

  getContractList() {
    if (this.dataService.userDisplayInfo.UserTypeID === 5) {
      return this.searchContract();
    }

    return this.authHttp.get(`/api/contract/GetContractList`, { headers: this.myHeader }).map(res => {
      // tslint:disable-next-line:triple-equals

      if (res.status === 401) {

        //this.authService.logOut();
      }
      if (res.status < 200 || res.status > 300) {
        throw new Error('getContractList request has failed ' + res.status);
      } else {
        this.setContracts(res.json());

        //  alert('logloglog: refetch contracts');
        console.log('logloglog: refetch contracts.');
        return res.json();
      }
    }).catch(err => {

      if (err.status === 401 || err.message === 'No JWT present or has expired') {
        this.authService.logOut();
      }

      return Observable.throw(err);
    });
  }

  setSelectedContract(contractNumber: string) {
    if (!contractNumber) {
      throw new Error('getContactByContractNumber failed. No contractNumber');
    }

    this.selectedContractNumber = contractNumber;
    return this.authHttp.get(`/api/contract/GetContractByContractNumber?psContractNumber=${contractNumber}`,
      { headers: this.myHeader }).map(res => {
        if (res.status < 200 || res.status > 300) {
          throw new Error('getContactByContractNumber request has failed ' + res.status);
        } else {
          // Set the selected contract;
          this.selectedContract = res.json();

          return res.json();
        }
      }).catch(err => {

        if (err.status === 401 || err.message === 'No JWT present or has expired') {
          this.authService.logOut();
        }

        return Observable.throw(err);
      });
  }


  // async getContractListPromise(): Promise<any> {
  //   // if (this.dataService.userDisplayInfo.UserTypeID === 5) {
  //   //   return this.searchContract();
  //   // }

  //   return this.authHttp.get(`/api/contract/GetContractList`, { headers: this.myHeader }).toPromise().then(res => {
  //     // tslint:disable-next-line:triple-equals
  //     if (res.status == 401) {
  //       this.authService.logOut();
  //     }
  //     if (res.status < 200 || res.status > 300) {
  //       throw new Error('getContractList request has failed ' + res.status);
  //     } else {
  //       this.setContracts(res.json());

  //       console.log('logloglog: refetch contracts.');
  //       return res.json();
  //     }
  //   });
  // }


  // setSelectedContract(contractNumber: string, registrationNumber = '') {
  //   for (let i = 0; i < this.contracts.length; i++) {
  //     if (this.contracts[i].ContractNumber === contractNumber) {
  //       this.selectedContract = this.contracts[i];
  //       if (registrationNumber !== '') {
  //         this.selectedContract.Registration = registrationNumber;
  //       }
  //     }
  //   }
  // }

  addNewcontract(addContract: AddContract) {
    return this.authHttp.post(`/api/contract/AddContract`, addContract, { headers: this.myHeader }).map(res => {
      if (res.status < 200 || res.status > 300) {
        throw new Error('add new contract request has failed ' + res.status);
      } else {
        return res.json();
      }
    }).catch(err => {

      if (err.status === 401 || err.message === 'No JWT present or has expired') {
        this.authService.logOut();
      }

      return Observable.throw(err);
    });
  }

  getContractsWithAdminRoleByLID(childLID: string) {
    return this.authHttp.get(`/api/contract/GetContractWithAdminRoleByLID?piChildLID=` + childLID, { headers: this.myHeader }).map(res => {
      if (res.status < 200 || res.status > 300) {
        throw new Error('Get contracts with Admin Role request has failed ' + res.status);
      } else {
        return res.json();
      }
    }).catch(err => {

      if (err.status === 401 || err.message === 'No JWT present or has expired') {
        this.authService.logOut();
      }

      return Observable.throw(err);
    });
  }

  getOverview(contractNumber: string) {
    return this.authHttp.get(`/api/contract/Overview?ContractNumber=${contractNumber}`, { headers: this.myHeader }).map(res => {
      if (res.status < 200 || res.status > 300) {
        throw new Error('Get contracts overview request has failed ' + res.status);
      } else {
        return res.json();
      }
    }).catch(err => {

      if (err.status === 401 || err.message === 'No JWT present or has expired') {
        this.authService.logOut();
      }

      return Observable.throw(err);
    });
  }

  setSearchText(searchText: string) {

    const isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);

    if (isIEOrEdge) {
      Cookie.remove('searchText');
      if (searchText) {
        this.searchText = searchText.trim();
        Cookie.set('searchText', searchText.trim());
      }
    } else {
      localStorage.removeItem('searchText');
      if (searchText) {
        this.searchText = searchText.trim();
        localStorage.setItem('searchText', this.searchText);
      }
    }

  }

  setContracts(contracts: Contract[]) {
    this.contracts = contracts;
  }

  searchContract() {
    if (!this.searchText) {
      this.setContracts(null);

      return Observable.of([]);
    } else {
      return this.authHttp.get(`/api/contract/SearchContract?input=${this.searchText}`, { headers: this.myHeader }).map(res => {
        if (res.status < 200 || res.status > 300) {
          throw new Error('Get contracts overview request has failed ' + res.status);
        } else {

          this.setContracts(res.json());

          return res.json();
        }
      }).catch(err => {

        if (err.status === 401 || err.message === 'No JWT present or has expired') {
          this.authService.logOut();
        }

        return Observable.throw(err);
      });
    }
  }

  getPostedInvoices() {
    return this.authHttp.get(`/api/contract/GetPostedInvoices`, { headers: this.myHeader }).map(res => {
      if (res.status < 200 || res.status > 300) {
        throw new Error('Get posted invoices request has failed ' + res.status);
      } else {
        return res.json();
      }
    }).catch(err => {

      if (err.status === 401 || err.message === 'No JWT present or has expired') {
        this.authService.logOut();
      }

      return Observable.throw(err);
    });
  }
  getPastDueInvoices() {
    return this.authHttp.get(`/api/contract/GetPastDueInvoices`, { headers: this.myHeader }).map(res => {
      if (res.status < 200 || res.status > 300) {
        throw new Error('Get Past Due invoices request has failed ' + res.status);
      } else {
        return res.json();
      }
    }).catch(err => {

      if (err.status === 401 || err.message === 'No JWT present or has expired') {
        this.authService.logOut();
      }

      return Observable.throw(err);
    });
  }
  DownloadpostedInvoices(postedInvoices: PostInvoiceList) {
    return this.authHttp.post(`/api/Report/DownloadZipLocally`, postedInvoices)
      .map(res => {
        if (res.status < 200 || res.status > 300) {
          throw new Error('CreateInvoiceSubmitHours has failed ' + res.status);
        } else {
          return res.json();
        }
      }).catch(err => {

        if (err.status === 401 || err.message === 'No JWT present or has expired') {
          this.authService.logOut();
        }

        return Observable.throw(err);
      });
  }
  getOverviewContacts(contractNumber: string) {
    return this.authHttp.get(`/api/contract/GetOverviewContacts?psContractNumber=${contractNumber}`,
      { headers: this.myHeader }).map(res => {
        if (res.status < 200 || res.status > 300) {
          throw new Error('getOverviewContacts request has failed ' + res.status);
        } else {
          return res.json();
        }
      }).catch(err => {

        if (err.status === 401 || err.message === 'No JWT present or has expired') {
          this.authService.logOut();
        }

        return Observable.throw(err);
      });
  }

  getOverviewFlightDetails(contractNumber: string) {
    return this.authHttp.get(`/api/contract/GetContractOverviewFlightDetails?psContractNumber=${contractNumber}`,
      { headers: this.myHeader }).map(res => {
        if (res.status < 200 || res.status > 300) {
          throw new Error('getOverviewFlightDetails request has failed ' + res.status);
        } else {
          return res.json();
        }
      }).catch(err => {

        if (err.status === 401 || err.message === 'No JWT present or has expired') {
          this.authService.logOut();
        }

        return Observable.throw(err);
      });
  }

  getContractExhibitC(contractNumber: string) {
    return this.authHttp.get(`/api/contract/GetContractExhibitC?psContractNumber=${contractNumber}`,
      { headers: this.myHeader }).map(res => {
        if (res.status < 200 || res.status > 300) {
          throw new Error('getContractExhibitC request has failed ' + res.status);
        } else {
          return res.json();
        }
      }).catch(err => {

        if (err.status === 401 || err.message === 'No JWT present or has expired') {
          this.authService.logOut();
        }

        return Observable.throw(err);
      });
  }

  UpdateRegistratonNumber(registraton: Registration) {
    return this.authHttp.post(`/api/contract/UpdateRegistration`, registraton, { headers: this.myHeader }).map(res => {
      if (res.status < 200 || res.status > 300) {
        throw new Error('add new contract request has failed ' + res.status);
      } else {
        return res.json();
      }
    }).catch(err => {

      if (err.status === 401 || err.message === 'No JWT present or has expired') {
        this.authService.logOut();
      }

      return Observable.throw(err);
    });
  }

  generateContractDoc(docData: any) {

    return this.authHttp.post(`/api/contract/GenerateContractDoc`, docData, { headers: this.myHeader }).map(res => {
      if (res.status < 200 || res.status > 300) {
        throw new Error('pdf file failed to be generated.' + res.status);
      } else {
        return res.json();
      }
    }).catch(err => {

      if (err.status === 401 || err.message === 'No JWT present or has expired') {
        this.authService.logOut();
      }

      return Observable.throw(err);
    });
  }

  getTechCases(contractNumber: string) {
    return this.authHttp.get(`/api/contract/GetTechCases?psContractNumber=${contractNumber}`,
      { headers: this.myHeader }).map(res => {
        if (res.status < 200 || res.status > 300) {
          throw new Error('getTechCases request has failed ' + res.status);
        } else {
          return res.json();
        }
      }).catch(err => {

        if (err.status === 401 || err.message === 'No JWT present or has expired') {
          this.authService.logOut();
        }

        return Observable.throw(err);
      });
  }

  async getConfig(key: string): Promise<any> {
    return this.authHttp.get(`/api/Contract/GetConfig?psKey=` + key,
      { headers: this.myHeader }).toPromise().then(function (res) {
        console.log(res);
        return res.text();
      }).catch(err => {

        if (err.status === 401 || err.message === 'No JWT present or has expired') {
          this.authService.logOut();
        }

        return Observable.throw(err);
      });
  }

  async getConfigLogin(key: string): Promise<any> {
    return this.http.get(`/api/Login/GetConfig?psKey=` + key,
      { headers: this.myHeader }).toPromise().then(function (res) {
        console.log(res);
        return res.text();
      }).catch(err => {

        if (err.status === 401 || err.message === 'No JWT present or has expired') {
          this.authService.logOut();
        }

        return Observable.throw(err);
      });
  }

  // getInvoiceFile() {
  //   return this.authHttp.get(`/api/contract/ViewFile?id=1`,
  //     { headers: this.myHeader }).map(res => {
  //       if (res.status < 200 || res.status > 300) {
  //         throw new Error('getInvoiceFile has failed ' + res.status);
  //       } else {
  //         return res.json();
  //       }
  //     });
  // }

  sendAFSale(contract:string){
    console.log('inside sendsfsales service call'+contract);

   return this.authHttp.post(`/api/contract/sendAFSaleinfo?contract=`+ contract, { headers: this.myHeader })
  .map(res => {
    if (res.status < 200 || res.status > 300) {
      throw new Error('sendAf sale has failed ' + res.status);
    } else {
      return res.json();
    }
  }).catch(err => {
    console.log('inside sendsfsales service call error');
    if (err.status === 401 || err.message === 'No JWT present or has expired') {
      this.authService.logOut();
    }

    return Observable.throw(err);
  });
}

 DownLoadDocInfo(contract:string, Doctype:string) {
       
        return this.authHttp.post(`/api/Contract/`+Doctype+`?ContractNumber=`+contract, { headers: this.myHeader }).map(res => {
          if (res.status < 200 || res.status > 300) {
            throw new Error('GeneratePdf has failed ' + res.status);
          } else {
            return res.json();
          }
        });
      }
}








// WEBPACK FOOTER //
// ./src/app/services/contract.service.ts